import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import IconButton from "@mui/material/IconButton";
import { useSelector } from "react-redux";
import configServ from "../../../services/config";
import Typography from "@mui/material/Typography";
import { Box, Card, CardContent } from "@mui/material";
import LoaderNew from "../../Loader/LoaderNew";
import CheckAndReturn from "../../../utility/CheckAndReturn";

const DetailRow = ({ label, value }) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    m={1}
  >
    <Typography variant="body1" fontWeight={700}>
      {label}:
    </Typography>
    <Typography variant="body1">{value ?? ""}</Typography>
  </Box>
);

const InvoiceDispatchDialog = ({ open, handleClose, invoice_number }) => {
  const [loading, setLoading] = React.useState(true);
  const { company_id } = useSelector((state) => state.GlobalVariables);
  const [dispatchDetails, setDispatchDetails] = React.useState([]);

  const fetchDispatchDetails = async () => {
    try {
      setLoading(true);
      const dataToSend = {
        company_id,
        search_by: "invoice_number",
        search: invoice_number,
        per_page: 10,
        page: 0,
      };
      const res = await configServ.getDispatch(dataToSend);
      if (res.status === 200) {
        setDispatchDetails(res.data || []);
      } else {
        setDispatchDetails([]);
      }
    } catch (e) {
      console.log(e);
      setDispatchDetails([]);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (open && invoice_number) {
      fetchDispatchDetails();
    }
  }, [open, invoice_number]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" color="error" fontWeight="bold">
            DISPATCH DETAILS
          </Typography>
          <IconButton onClick={handleClose}>
            <DisabledByDefaultIcon fontSize="large" color="error" />
          </IconButton>
        </Box>
        <Box sx={{ maxHeight: "400px", overflowY: "auto" }}>
          {loading ? (
            <LoaderNew />
          ) : dispatchDetails.length > 0 ? (
            dispatchDetails.map((detail, index) => (
              <Card
                key={detail.id || index}
                sx={{
                  margin: "10px 0",
                  boxShadow: index % 2 === 0 ? 3 : 1,
                  backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
                }}
              >
                <CardContent>
                  <DetailRow
                    label="Invoice No"
                    value={detail.invoice_no || detail.invoice_number}
                  />
                  <DetailRow
                    label="Transporter Name"
                    value={detail.transporter_name}
                  />
                  <DetailRow
                    label="Phone"
                    value={detail.TransporterMobileNo}
                  />
                  <DetailRow label="Vehicle No" value={detail.vehicle_num} />
                  <DetailRow label="Quantity" value={detail.qnty} />
                  <DetailRow
                    label="Amount"
                    value={detail.amount != null ? `₹${detail.amount}` : ""}
                  />
                  <DetailRow
                    label="Dispatch Date"
                    value={
                      detail.Date
                        ? CheckAndReturn.transformToDate3(detail.Date)
                        : ""
                    }
                  />
                  {Boolean(detail.is_ewaybill) && (
                    <>
                      <DetailRow
                        label="E-way Bill No"
                        value={detail.eWayBillNo}
                      />
                      <DetailRow
                        label="E-way Bill Date"
                        value={
                          detail.ewaybill_date
                            ? CheckAndReturn.transformToDate3(
                                detail.ewaybill_date
                              )
                            : ""
                        }
                      />
                      <DetailRow
                        label="E-way Bill Validity"
                        value={
                          detail.ewaybill_validity
                            ? CheckAndReturn.transformToDate3(
                                detail.ewaybill_validity
                              )
                            : ""
                        }
                      />
                    </>
                  )}
                </CardContent>
              </Card>
            ))
          ) : (
            <Typography>No dispatch details found.</Typography>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default InvoiceDispatchDialog;
